import { useQuery } from "@tanstack/react-query";

import { getPostDetails, PostDetailsData } from "../services/postServices";
import { FEED_QUERY_KEYS } from "../queryKeys";

export const usePostDetailsQuery = (postId: number) => {
  return useQuery<PostDetailsData, Error>({
    queryKey: FEED_QUERY_KEYS.postData(postId),
    queryFn: async () => {
      return await getPostDetails(postId);
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
